 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"account-remove":"account-remove","audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~auth-create~auth-login~auth-mf~dde4879c":"audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~auth-create~auth-login~auth-mf~dde4879c","audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~auth-create~config-drag-drop~d~d67ec39f":"audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~auth-create~config-drag-drop~d~d67ec39f","audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~dash-albums-form~dash-albums-l~7b69d3da":"audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~dash-albums-form~dash-albums-l~7b69d3da","audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~dash-audio-form~dash-audio-rev~b5d1aa7d":"audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~dash-audio-form~dash-audio-rev~b5d1aa7d","audio-approveds":"audio-approveds","audio-approving":"audio-approving","audio-exam":"audio-exam","audio-review":"audio-review","audio-review2":"audio-review2","dash-albums-form~dash-learn-page-form":"dash-albums-form~dash-learn-page-form","dash-albums-form":"dash-albums-form","dash-albums-list":"dash-albums-list","dash-dashboard-charts~dash-learn-page-search~dash-updates-form~dash-updates-list":"dash-dashboard-charts~dash-learn-page-search~dash-updates-form~dash-updates-list","dash-learn-page-search":"dash-learn-page-search","dash-usersearch":"dash-usersearch","dash-audio-form~dash-audio-review":"dash-audio-form~dash-audio-review","dash-audio-form":"dash-audio-form","dash-audio-review":"dash-audio-review","notification-form":"notification-form","auth-create":"auth-create","dash-learn-page-form":"dash-learn-page-form","config-drag-drop":"config-drag-drop","dash-updates-form":"dash-updates-form","dash-dashboard-charts":"dash-dashboard-charts","auth-login":"auth-login","auth-mfa":"auth-mfa","auth-passwordforcerenew":"auth-passwordforcerenew","auth-passwordforgot":"auth-passwordforgot","auth-passwordinvite":"auth-passwordinvite","auth-recovery":"auth-recovery","dash-updates-list":"dash-updates-list","player":"player"}[chunkId]||chunkId) + "." + {"account-remove":"de39dc7d","audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~auth-create~auth-login~auth-mf~dde4879c":"860e0bc0","audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~auth-create~config-drag-drop~d~d67ec39f":"906e4b68","audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~dash-albums-form~dash-albums-l~7b69d3da":"aa7bcd79","audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~dash-audio-form~dash-audio-rev~b5d1aa7d":"8b67f5e1","audio-approveds":"9080f493","audio-approving":"be8952e6","audio-exam":"03936296","audio-review":"3fcb4658","audio-review2":"4716f76a","dash-albums-form~dash-learn-page-form":"edfac62e","dash-albums-form":"07859cb3","dash-albums-list":"0cd18934","dash-dashboard-charts~dash-learn-page-search~dash-updates-form~dash-updates-list":"8220d7af","dash-learn-page-search":"e45b7f3e","dash-usersearch":"4ddede46","dash-audio-form~dash-audio-review":"29a71c94","dash-audio-form":"13c738c3","dash-audio-review":"24bf53de","notification-form":"82eb8e69","auth-create":"3d360e8b","chunk-21f05f00":"fe50a6a9","dash-learn-page-form":"355ca97f","config-drag-drop":"0fa88539","dash-updates-form":"fd1df633","dash-dashboard-charts":"8104d2f6","auth-login":"749cc3a9","auth-mfa":"b59861dc","auth-passwordforcerenew":"c1788059","auth-passwordforgot":"967029f6","auth-passwordinvite":"a3641e14","auth-recovery":"8a9ec566","dash-updates-list":"407b4ccf","player":"9f90b3a6","chunk-2d207f75":"729edfc2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"account-remove":1,"audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~auth-create~auth-login~auth-mf~dde4879c":1,"audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~auth-create~config-drag-drop~d~d67ec39f":1,"audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~dash-albums-form~dash-albums-l~7b69d3da":1,"audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~dash-audio-form~dash-audio-rev~b5d1aa7d":1,"audio-approveds":1,"audio-approving":1,"audio-exam":1,"audio-review":1,"audio-review2":1,"dash-albums-form~dash-learn-page-form":1,"dash-albums-form":1,"dash-albums-list":1,"dash-learn-page-search":1,"dash-usersearch":1,"dash-audio-form":1,"auth-create":1,"chunk-21f05f00":1,"dash-learn-page-form":1,"config-drag-drop":1,"dash-updates-form":1,"dash-dashboard-charts":1,"auth-login":1,"auth-mfa":1,"auth-passwordforcerenew":1,"auth-passwordforgot":1,"auth-passwordinvite":1,"auth-recovery":1,"dash-updates-list":1,"player":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"account-remove":"account-remove","audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~auth-create~auth-login~auth-mf~dde4879c":"audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~auth-create~auth-login~auth-mf~dde4879c","audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~auth-create~config-drag-drop~d~d67ec39f":"audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~auth-create~config-drag-drop~d~d67ec39f","audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~dash-albums-form~dash-albums-l~7b69d3da":"audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~dash-albums-form~dash-albums-l~7b69d3da","audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~dash-audio-form~dash-audio-rev~b5d1aa7d":"audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~dash-audio-form~dash-audio-rev~b5d1aa7d","audio-approveds":"audio-approveds","audio-approving":"audio-approving","audio-exam":"audio-exam","audio-review":"audio-review","audio-review2":"audio-review2","dash-albums-form~dash-learn-page-form":"dash-albums-form~dash-learn-page-form","dash-albums-form":"dash-albums-form","dash-albums-list":"dash-albums-list","dash-dashboard-charts~dash-learn-page-search~dash-updates-form~dash-updates-list":"dash-dashboard-charts~dash-learn-page-search~dash-updates-form~dash-updates-list","dash-learn-page-search":"dash-learn-page-search","dash-usersearch":"dash-usersearch","dash-audio-form~dash-audio-review":"dash-audio-form~dash-audio-review","dash-audio-form":"dash-audio-form","dash-audio-review":"dash-audio-review","notification-form":"notification-form","auth-create":"auth-create","dash-learn-page-form":"dash-learn-page-form","config-drag-drop":"config-drag-drop","dash-updates-form":"dash-updates-form","dash-dashboard-charts":"dash-dashboard-charts","auth-login":"auth-login","auth-mfa":"auth-mfa","auth-passwordforcerenew":"auth-passwordforcerenew","auth-passwordforgot":"auth-passwordforgot","auth-passwordinvite":"auth-passwordinvite","auth-recovery":"auth-recovery","dash-updates-list":"dash-updates-list","player":"player"}[chunkId]||chunkId) + "." + {"account-remove":"4b8296db","audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~auth-create~auth-login~auth-mf~dde4879c":"65194e6d","audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~auth-create~config-drag-drop~d~d67ec39f":"6a0d8d60","audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~dash-albums-form~dash-albums-l~7b69d3da":"daca5a6e","audio-approveds~audio-approving~audio-exam~audio-review~audio-review2~dash-audio-form~dash-audio-rev~b5d1aa7d":"155f55f5","audio-approveds":"0cf4e35f","audio-approving":"0cf4e35f","audio-exam":"0cf4e35f","audio-review":"0cf4e35f","audio-review2":"0cf4e35f","dash-albums-form~dash-learn-page-form":"155f55f5","dash-albums-form":"5926c8c7","dash-albums-list":"8b2bc380","dash-dashboard-charts~dash-learn-page-search~dash-updates-form~dash-updates-list":"31d6cfe0","dash-learn-page-search":"89f7d680","dash-usersearch":"e0100b76","dash-audio-form~dash-audio-review":"31d6cfe0","dash-audio-form":"56466c75","dash-audio-review":"31d6cfe0","notification-form":"31d6cfe0","auth-create":"4938b8de","chunk-21f05f00":"ac214cef","dash-learn-page-form":"8923a3f6","config-drag-drop":"d44ae2a1","dash-updates-form":"301dd0f2","dash-dashboard-charts":"10d1fc62","auth-login":"bc310720","auth-mfa":"ebe82f35","auth-passwordforcerenew":"71c202de","auth-passwordforgot":"71c202de","auth-passwordinvite":"71c202de","auth-recovery":"bc310720","dash-updates-list":"aeaa919b","player":"760e14ae","chunk-2d207f75":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
